/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Product_CatalogInputs */

const en_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product catalog`)
};

const ar_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كتالوج المنتجات`)
};

const bn_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পণ্য ক্যাটালগ`)
};

const de_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktkatalog`)
};

const es_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo de productos`)
};

const fr_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogue de produits`)
};

const pt_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo de produtos`)
};

const zh_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品目录`)
};

const tr_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün kataloğu`)
};

const ru_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каталог товаров`)
};

const pl_svchip_product_catalog = /** @type {(inputs: Svchip_Product_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog produktów`)
};

/**
* | output |
* | --- |
* | "Product catalog" |
*
* @param {Svchip_Product_CatalogInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_product_catalog = /** @type {((inputs?: Svchip_Product_CatalogInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Product_CatalogInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_product_catalog(inputs)
	if (locale === "bn") return bn_svchip_product_catalog(inputs)
	if (locale === "de") return de_svchip_product_catalog(inputs)
	if (locale === "es") return es_svchip_product_catalog(inputs)
	if (locale === "fr") return fr_svchip_product_catalog(inputs)
	if (locale === "pt") return pt_svchip_product_catalog(inputs)
	if (locale === "zh") return zh_svchip_product_catalog(inputs)
	if (locale === "tr") return tr_svchip_product_catalog(inputs)
	if (locale === "ru") return ru_svchip_product_catalog(inputs)
	if (locale === "pl") return pl_svchip_product_catalog(inputs)
	return en_svchip_product_catalog(inputs)
});